// extracted by mini-css-extract-plugin
export default {"profile":"MyProfile_profile__OOe4b","category":"MyProfile_category__RUnil","btn-unreserve":"MyProfile_btn-unreserve__6GuJF","btn-more":"MyProfile_btn-more__AcJla"};